export default __webpack_public_path__ + "maps-examples-camera-animation-thumbnail-960-82b1cfecdb97e668b295fa8ca346a649.png";